<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Section Incomplete
        </p>
        <button
          id="modal-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <p>You have <b>NOT</b> completed this section. Please enter the information required, or check the box above indicating that you have nothing to report. Do you want to continue without completing this section at this time?</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          id="modal-yes-btn"
          type="button"
          class="button is-dark"
          @click="goTo"
        >
          Yes
        </button>
        <button
          id="modal-no-btn"
          type="button"
          class="button is-primary"
          @click="$emit('close')"
        >
          No
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SectionIncomplete',
  props: {
    pathName: {
      required: true,
      type: String,
      default: '',
    },
  },
  methods: {
    goTo () {
      this.$emit('close');
      this.$router.push({ name: this.pathName });
    },
  },
};
</script>